// extracted by mini-css-extract-plugin
export default {"details":"order-details_details__x+sgv","order":"order-details_order__Hc73h","image":"order-details_image__iEeUo"};